module.exports = __webpack_public_path__ + "img/FYILogo.53f6c92d.png";